/** @format */


type RatingProps = {
  rating?: number;
};

export const Rating = ({ rating = 0 }: RatingProps) => {
  return (
    <div className="list-item-rating">
      {Array.from({ length: 5 }).map((_, index) => (
        <span key={index} className={index < Math.round(rating) ? 'rated' : ''}></span>
      ))}
    </div>
  );
};
